import React, { useState, useEffect, useContext } from "react";
import peij from "../../../services/peij";
import AppContext from "../../../container/context";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";
import ijws from "../../../services/ijws";

const Nivel = ({ match, history }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const nivelId = Number(match.params.id);
  const [nivel, setNivel] = useState({});

  useEffect(() => {
    if (nivelId > 0) {
      carregarNivel();
    }
  }, [nivelId]);

  const carregarNivel = () => {
    setCarregando(true);

    ijws
      .get("admin/niveis/carregar", { id: nivelId })
      .then((nivel) => {
        setNivel(nivel);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível carregar o nível");
        setCarregando(false);
      });
  };

  const formularioNivel = (nivel) => ({
    nome: {
      label: "Nome",
      type: "text",
      value: nivel.nome,
      required: true,
      space: 8,
    },
    ordem: {
      label: "Ordem",
      type: "number",
      value: nivel.ordem,
      space: 4,
    },
    descricao: {
      label: "Descrição",
      type: "textarea",
      value: nivel.descricao,
      space: 12,
    },
    ativo: {
      label: "Ativo",
      type: "check",
      value: nivel.id > 0 ? nivel.ativo : true,
      space: 12,
    },
  });

  const salvar = (formulario) => {
    const nivel = formulario;

    if (nivelId > 0) {
      nivel.id = nivelId;

      ijws
        .post("admin/niveis/editar", nivel)
        .then((res) => {
          notification("success", "Nível salvo!");
          history.goBack();
        })
        .catch((e) => {
          const { data } = e;
          if (data.includes(1)) return notification("error", "Nome inválido");
        });
    } else {
      ijws
        .post("admin/niveis/inserir", nivel)
        .then((res) => {
          notification("success", "Nível salvo!");
          history.goBack();
        })
        .catch((e) => {
          const { data } = e;
          if (data.includes(1)) return notification("error", "Nome inválido");
        });
    }
  };

  const fForm = {
    form: formularioNivel(nivel),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: {},
    history,
  };

  return (
    <div>
      {carregando ? (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <CircularProgress color="info" />
        </div>
      ) : (
        <Form formData={fForm} />
      )}
    </div>
  );
};

export default Nivel;
